
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton } from '@/components';
import { useGameReport } from '@/modules/game/report/model/edit';
import { ROUTE_NAME_GAME } from '@/modules/game/router';

export default defineComponent({
    name: ROUTE_NAME_GAME.REPORT,
    components: { AppFormRow, AppInput, AppCard, AppButton },
    setup() {
        const { model, v$, fetch, actions } = useGameReport();

        onMounted(async () => {
            await fetch();
        });

        return { model, v$, actions };
    }
});
